import { cn } from '../../lib/utils';

export default function SurfaceHero({ eyebrow, title, detail, aside, className }) {
  return (
    <div className={cn('flex flex-col gap-3 md:flex-row md:items-end md:justify-between', className)}>
      <div>
        {eyebrow ? <p className="text-sm uppercase tracking-[0.24em] text-muted-foreground">{eyebrow}</p> : null}
        <h1 className="font-serif text-3xl text-foreground">{title}</h1>
        {detail ? <p className="mt-2 max-w-2xl text-sm leading-6 text-muted-foreground">{detail}</p> : null}
      </div>
      {aside ? <div className="flex shrink-0 items-center gap-2">{aside}</div> : null}
    </div>
  );
}
